<template lang="pug">
  div.d-flex.justify-center.align-center(style="height: 100%")
    div(style="position: absolute" align="center")
      img(:src="require('@/assets/images/icon_yezza_qr.png')" style="width: 75px")
    vue-qrcode(:value="getLink" :options="{ width: 300 }")
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  name: 'PrintQrCode',
  components: { VueQrcode },
  computed: {
    getLink () {
      if (this.$route.query.store === 'true') {
        return `https://${this.$route.query.link}.${process.env.VUE_APP_STORE_URL_DOMAIN}/`
      } else {
        return `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.$route.query.link}/`
      }
    }
  },
  mounted () {
    window.print()
    window.onafterprint = function(){
      window.close()
    }
  }
}
</script>